module.exports = __webpack_public_path__ + "img/vegetable-chard-350x184.766960b1.jpg";